import { useState } from "react";
import "./pin-access-form.css";

type PinAccessFormProps = {
  verify: (pin: string) => Promise<void>;
  eyebrow: string;
  title: string;
  description: string;
  label: string;
  submitLabel: string;
  scope: string;
};

export function PinAccessForm({
  verify,
  eyebrow,
  title,
  description,
  label,
  submitLabel,
  scope,
}: PinAccessFormProps) {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <main className="pin-access-form">
      <form
        onSubmit={(event) => {
          event.preventDefault();
          if (pin.length !== 6 || busy) return;
          setBusy(true);
          setError(null);
          void verify(pin)
            .catch((reason: unknown) => {
              setPin("");
              setError(reason instanceof Error ? reason.message : "PIN doğrulanamadı.");
            })
            .finally(() => setBusy(false));
        }}
      >
        <img className="pin-access-form-brand" src="/anl-logo-new-2026.webp" alt="ANL" width={42} height={42} />
        <p className="pin-access-form-eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p>{description}</p>
        <label htmlFor="personal-pin">{label}</label>
        <input
          id="personal-pin"
          type="password"
          inputMode="numeric"
          autoComplete="off"
          maxLength={6}
          value={pin}
          aria-invalid={error ? "true" : undefined}
          aria-describedby={error ? "personal-pin-error personal-pin-scope" : "personal-pin-scope"}
          onChange={(event) => setPin(event.target.value.replace(/\D/gu, "").slice(0, 6))}
          autoFocus
        />
        {error ? <p id="personal-pin-error" className="pin-access-form-error" role="alert">{error}</p> : null}
        <button type="submit" disabled={pin.length !== 6 || busy}>{busy ? "Doğrulanıyor…" : submitLabel}</button>
        <small id="personal-pin-scope">{scope}</small>
      </form>
    </main>
  );
}
